import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading" theme="lightest" className="titleBlock-align-left benefitsForEnterprises" mdxType="TitleBlock" />
    <h2 {...{
      "id": "benefits-for-enterprises-across-the-board"
    }}>{`Benefits for enterprises across the board.`}</h2>
    <TextBlock slots="image, heading, text" width="25%" theme="lightest" className="align-left icon-xl-size horizontal-align-heading Benefits-one" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "161px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "99.37888198757763%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/61e0655d353cca76e2a34b2a17e6e196/681c1/efficiency_Icon_Desktop.webp 161w"],
            "sizes": "(max-width: 161px) 100vw, 161px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/61e0655d353cca76e2a34b2a17e6e196/67b6b/efficiency_Icon_Desktop.png 161w"],
            "sizes": "(max-width: 161px) 100vw, 161px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/61e0655d353cca76e2a34b2a17e6e196/67b6b/efficiency_Icon_Desktop.png",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "efficiency-and-productivity"
    }}>{`Efficiency and productivity.`}</h3>
    <p>{`Get your products and services to market faster, increase the productivity of your teams, and improve accuracy with low-code automations.`}</p>
    <TextBlock slots="image, heading, text" width="25%" theme="lightest" className="align-left icon-xl-size horizontal-align-heading Benefits-two" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "160px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/3eca3f85e3aef137502e83bfb640df28/748b5/savings_Icon_Desktop.webp 160w"],
            "sizes": "(max-width: 160px) 100vw, 160px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/3eca3f85e3aef137502e83bfb640df28/065de/savings_Icon_Desktop.png 160w"],
            "sizes": "(max-width: 160px) 100vw, 160px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/3eca3f85e3aef137502e83bfb640df28/065de/savings_Icon_Desktop.png",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "cost-savings"
    }}>{`Cost savings.`}</h3>
    <p>{`Save on licensing costs with volume discounts, easier procurement process, and pooled transactions through Adobe.`}</p>
    <TextBlock slots="image, heading, text" width="25%" theme="lightest" className="align-left icon-xl-size link horizontal-align-heading linking Benefits-three" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "160px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/1b50910f9a1fe8679a22279aeeab1975/748b5/ai_Icon_Desktop.webp 160w"],
            "sizes": "(max-width: 160px) 100vw, 160px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/1b50910f9a1fe8679a22279aeeab1975/065de/ai_Icon_Desktop.png 160w"],
            "sizes": "(max-width: 160px) 100vw, 160px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/1b50910f9a1fe8679a22279aeeab1975/065de/ai_Icon_Desktop.png",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "the-latest-ai-technology"
    }}>{`The latest AI technology.`}</h3>
    <p>{`Innovate with Adobe Sensei AI and machine learning for highly accurate document processing and data extraction.`}</p>
    <TextBlock slots="image, heading, text" width="25%" theme="lightest" className="align-left icon-xl-size link horizontal-align-heading linking Benefits-four" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "160px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/8d80bc99618fa34e8a989875f3372d16/748b5/security_Icon_Desktop.webp 160w"],
            "sizes": "(max-width: 160px) 100vw, 160px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/8d80bc99618fa34e8a989875f3372d16/065de/security_Icon_Desktop.png 160w"],
            "sizes": "(max-width: 160px) 100vw, 160px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/8d80bc99618fa34e8a989875f3372d16/065de/security_Icon_Desktop.png",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "security-reliability-scalability"
    }}>{`Security, reliability, scalability.`}</h3>
    <p>{`With Adobe, you get enterprise-grade security, reliability, and scalability — so you don’t have to worry about the fine print.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      